exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media (min-width: 993px){\n.contactDebtorListButtonContainer {\n    margin-top: 4%;\n    margin-left: 260px;\n    margin-right: auto;\n    width: auto;\n}\n.searchbar {\n    margin-left: 260px;\n    margin-right: auto;\n    width: auto;\n}\n}\n@media (max-width: 992px){\n.contactDebtorListButtonContainer {\n    margin-top: 4%;\n    margin-left: 0%;\n    margin-right: 0%;\n}\n.searchbar {\n    margin-left: 0%;\n    margin-right: 0%;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9712db48","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/settings/CMRemindSettingContactList.vue
// module id = 1598
// module chunks = 2